import { Button, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useEffect, useRef, useState } from "react"

import { useCoachTodosQuery } from "../../networking/coachTodos/queries"

const TodoEmptyState = () => {
  const { refetch, isFetching } = useCoachTodosQuery()
  const [isAnimating, setIsAnimating] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const animatePartyPopper = () => {
    setIsAnimating(true)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      setIsAnimating(false)
    }, 2250)
  }

  useEffect(() => {
    animatePartyPopper()
    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current)
    }
  }, [])

  const handleRefresh = async () => {
    await refetch()
    animatePartyPopper()
  }

  return (
    <div className="flex flex-col py-16 items-center gap-4">
      <img
        src={
          isAnimating ? "/images/party_popper.gif" : "/images/party_popper.png"
        }
        alt="empty state"
        className="w-16 h-16"
      />
      <Typography variant="bodyBold" color={JoonUIColor.text.primary}>
        Woohoo clear to-dos!{" "}
      </Typography>
      <Button
        text="Refresh list"
        size="small"
        style={{ width: "150px" }}
        onClick={handleRefresh}
        isLoading={isFetching}
      />
    </div>
  )
}

export default TodoEmptyState
